import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';

export const physicalPrepaidCardStopCancel = http.patch(
  createMockEndpoint('/physical_prepaid_card/:cardNumber/stop_cancel'),
  async () => {
    await delay(500);
    return HttpResponse.json(null, { status: 200 });
  },
);
